'use client'

import { Container, Grid, Paper, Typography } from '@mui/material'

import { LoginForm } from '@/components/Forms/LoginForm'
import { useTranslations } from '@/hooks/useTranslations'

export const SignInClient = ({ callbackUrl }: { callbackUrl?: string }) => {
  const { translate } = useTranslations()

  return (
    <Container>
      <Grid container sx={{ my: [3, 6, 10] }}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Paper
            elevation={0}
            sx={(theme) => ({
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              borderRadius: '2px',
              px: 3,
              py: 5,
              maxWidth: theme.spacing(52),
            })}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Typography paragraph variant="h1">
                  {translate('sigIn.header')}
                </Typography>
                <LoginForm callbackUrl={callbackUrl} employeeSignIn={false} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      </Grid>
    </Container>
  )
}
